﻿import jquery from 'jquery';
import WindowModal from '../../Global/window-modal';
import HabEvents from '../../Global/habitaclia-events';

class ModalMapa{
    
    constructor(dataModalMap){
        this.dataModalMap = dataModalMap;
    }

    showModalMap() {
        jquery.ajax({
            url: this.dataModalMap.urlGetMap,
            data: 'arrayCodInmCodEmp=' + this.dataModalMap.codEmpCodInm + '&idioma=' + this.dataModalMap.idioma,
            type: 'POST',
            dataType: 'html',
            timeout: 15000,
            success: (data) => {
                if (data) {
                    this.createModalMap(jquery(data).find('#gMapImg').prop('outerHTML'));
                } else {
                    throw 'Error Al abrir mapa: No se han devuelto resultados';
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                const msg = `Error Al abrir mapa: responseText: ${jqXHR.responseText} textStatus: ${textStatus} errorThrown: ${errorThrown}`;
                throw msg;
            }
        });
    }
    createModalMap(content){
        const modalMap = new WindowModal();
        modalMap.OnReady(this.bindEventsModalMapa);
        modalMap.OnDestroy(this.unbindEventsModalMapa);
        modalMap.CreateWindowModal({
            idSelectorString: 'idHabDialogMapa',
            dataTitle: '<div class="titleModal">' + this.dataModalMap.dirEx + '</div><div class="closeModal closeModalMapa"></div>',
            dataBody: content,
            dataFooter: '<div id="mapamodal"><input onClick ="_gaq.push([\'_trackEvent\', \'Navegacion\', \'listamapa\', \'veranuncio\']); document.location.href = \'' + this.dataModalMap.link + '\';" type="button" class="boton" value="'+this.dataModalMap.translates.idDialogFooterCerrarAlertaModal+'" /></div>',
            modalWidth: '640px'
        });
    }



    bindEventsModalMapa() {
        jquery('.closeModalMapa').on('click', () => {
            jquery.publish(HabEvents.EventsEnum.CloseWindowModal);
//            TODO: [David] Mover al sistema de trackings
//            _gaq.push(['_trackEvent', 'Navegacion', 'listamapa', 'cerrarx']);
        });
//        if (typeof (_gaq) != 'undefined') {
//            _gaq.push(['_trackPageview', '/mapa?dialog=1']);
//        }
    }

    unbindEventsModalMapa() {
        jquery('.closeModalMapa').off('click');
    }
}

export default ModalMapa;
